import classnames from 'classnames'

import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import styles from './VideoWithText.module.css'

export interface VideoWithTextProps {
  flip: boolean
  theme?: ComponentTheme
  embedCode: string
  videoSummary: string
  testID?: string
  moduleId?: string
}

export default function VideoWithText({
  flip = false,
  theme = ComponentTheme.primary,
  embedCode,
  videoSummary,
  testID,
  moduleId,
}: VideoWithTextProps) {
  return (
    <Fixture theme={theme} verticalPadding={false} id={moduleId}>
      <div className={styles.base} data-testid={testID}>
        <div
          className={classnames(
            styles.videoWrapper,
            flip && styles.videoWrapperFlip
          )}
        >
          <div
            dangerouslySetInnerHTML={{ __html: embedCode }}
            className={styles.responsiveVideo}
          ></div>
        </div>

        <div
          className={classnames(
            styles.textWrapper,
            theme === ComponentTheme.secondary && styles.textWrapperPadb
          )}
        >
          <Container gutters={gutterTypes.always}>
            <Text size={TextSizes.bodyLrg} className={styles.body}>
              {videoSummary}
            </Text>
          </Container>
        </div>
      </div>
    </Fixture>
  )
}
